import { enrichConvertersRegistry } from '../../utils/convertersRegistry'
import { borderConverterMap } from './borderPropsToCss'

/**
 * Enriches the converters registry with all Border style property converters.
 * Border converters handle CSS border properties including width, style, color, and radius.
 */
export function enrichBorderConverters(): void {
	// Register all border converters
	Object.entries(borderConverterMap).forEach(([key, converter]) => {
		enrichConvertersRegistry(key, converter)
	})
}
